import {
  deselectColumns,
  setHoverDeleteButton,
} from '@databases/redux/cellSelections/actions';
import { appStore } from '@databases/redux/store';

/**
 * Handles the mouse leave event for the delete field button by clearing the hover state
 * and deselecting the specified columns.
 */
export function onMouseLeaveDeleteFieldButton(selectedFieldIds: string[]) {
  appStore.dispatch(setHoverDeleteButton({ value: null }));
  appStore.dispatch(
    deselectColumns({
      fieldIds: selectedFieldIds,
    })
  );
}
